// FP3-095 — Shared "Areas of Impact" broad-domain labels + chip colors.
// Mirror of /app/backend/services_config.py → DOMAINS (10 broad keys).
// Single frontend source for BOTH Admin Students and Provider Caseload
// so the two surfaces always render identical Areas of Impact chips.
export const DOMAIN_LABELS = {
  speech_language:   "Speech-Language",
  ot:                "Occupational Therapy",
  pt:                "Physical Therapy",
  social_behavior:   "Social-Emotional / Behavior",
  academics:         "Academics",
  hearing_vision:    "Hearing / Vision",
  transition:        "Transition / Independent Living",
  health_nursing:    "Health / Nursing",
  support_access:    "Support / Access Services",
  enrichment_other:  "Enrichment / Other",
};

export const DOMAIN_COLORS = {
  speech_language:   { bg: "bg-[#E1EAE4]",  fg: "text-[#1E5A3F]" },
  ot:                { bg: "bg-[#FDF8F3]",  fg: "text-[#9C6B2E]" },
  pt:                { bg: "bg-[#EEF1F6]",  fg: "text-[#3F4756]" },
  social_behavior:   { bg: "bg-[#F4ECEF]",  fg: "text-[#7C3F58]" },
  academics:         { bg: "bg-[#EEF1F6]",  fg: "text-[#4A5C7A]" },
  hearing_vision:    { bg: "bg-[#F0F1F2]",  fg: "text-[#5B6770]" },
  transition:        { bg: "bg-[#F7EEDD]",  fg: "text-[#9E7A3D]" },
  health_nursing:    { bg: "bg-[#FBEFEC]",  fg: "text-[#B85C5C]" },
  support_access:    { bg: "bg-[#F3F1EC]",  fg: "text-[#6B7280]" },
  enrichment_other:  { bg: "bg-[#F3EEF4]",  fg: "text-[#8B5A8C]" },
};
